export const SET_REVIEWS = 'SET_REVIEWS';
export const SET_REVIEW = 'SET_REVIEW';
export const ADD_REVIEW = 'ADD_REVIEW';
export const UPDATE_REVIEW = 'UPDATE_REVIEW';
export const REMOVE_REVIEW = 'REMOVE_REVIEW';
export const CLEAR_REVIEW = 'CLEAR_REVIEW';
export const CLEAR_REVIEWS = 'CLEAR_REVIEWS';
